export const LEAD_STATUSES = [
  { value: 'new', label: 'New', badge: 'info' },
  { value: 'contacted', label: 'Contacted', badge: 'pending' },
  { value: 'qualified', label: 'Qualified', badge: 'trial' },
  { value: 'won', label: 'Won', badge: 'active' },
  { value: 'lost', label: 'Lost', badge: 'cancelled' },
];

const BUSINESS_TYPE_LABELS = {
  ecommerce: 'E-commerce / D2C',
  education: 'Education',
  healthcare: 'Healthcare',
  real_estate: 'Real estate',
  restaurant: 'Restaurant / food',
  services: 'Local services',
  agency: 'Agency',
  other: 'Other',
};

export const PERIOD_OPTIONS = [7, 30, 90, 180, 365];

export function leadStatusMeta(status) {
  return LEAD_STATUSES.find((s) => s.value === status) || LEAD_STATUSES[0];
}

export function businessTypeLabel(value) {
  if (!value) return null;
  return BUSINESS_TYPE_LABELS[value] || value;
}

/** wa.me link for a stored E.164 number (digits, optional leading +). */
export function whatsappLink(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  return digits.length >= 8 ? `https://wa.me/${digits}` : null;
}

export function formatPhone(phone) {
  const digits = String(phone || '').replace(/\D/g, '');
  if (!digits) return '—';
  if (digits.length === 12 && digits.startsWith('91')) {
    return `+91 ${digits.slice(2, 7)} ${digits.slice(7)}`;
  }
  return `+${digits}`;
}

/** Share of sign-ups that carried a tracked source, e.g. "2 of 6 (33%)". */
export function trackedShare(withSource, total) {
  if (!total) return '0 of 0';
  return `${withSource} of ${total} (${Math.round((withSource / total) * 100)}%)`;
}
